<ng-container *transloco="let t">
  <div class="shipping-options-selector">
    <label class="ui-label">{{ t('shippingOptions.selectOptionLabel') }}</label>
    <p class="ui-helper">{{ t('shippingOptions.selectOptionHelper') }}</p>
    
    <pxw-input-radio-group
      class="shipping-options__list"
      name="shippingOption"
      [options]="shippingOptions()"
      [(ngModel)]="selectedOptionInternal"
      [valueKey]="'estimate'"
      [labelKey]="'label'"
      required
      [displayErrors]="isFormSubmitted()"
      layout="stacked"
    >
      <ng-template #itemTemplate let-shippingOption>
        <div class="shipping-options__item">
          <div class="shipping-options__header">
            <div class="shipping-options__service-info">
              <strong class="shipping-options__label">{{ shippingOption.label }}</strong>
              @if (shippingOption.deliveryTime) {
                <div class="shipping-options__delivery-time">
                  {{ shippingOption.deliveryTime }}
                </div>
              }
            </div>
            <strong class="shipping-options__price">{{ shippingOption.price | currency:'ARS':'symbol':'1.0-0' }}</strong>
          </div>
        </div>
      </ng-template>
    </pxw-input-radio-group>
  </div>
</ng-container> 